import { Component } from 'react';

import Link from 'components/link/link';

import VideoModal from '../modal/video';


class Button extends Component {
  render() {
    const { type, ...other } = this.props;

    //determine if we should render as a button or an anchor
    const renderType = type === 'button' || type === 'submit' ? 'button' : type;

    let component;

    switch (renderType) {
      case 'submit':
      case 'button':
        component = (
          <button
            type={ type }
            className={ `has-text-centered ${this.props.className}` }
            { ...other }
          >{this.props.text ||
            this.props.children ||
            'Start Free Trial'}</button>
        );
        break;
      case 'link':
        if (/(^\/(?!\/)|^https?:\/\/wheniwork\.com)/.test(this.props.href)) {
          const modifiedInternalLink = this.props.href.replace(
            /^https?:\/\/wheniwork\.com/,
            ''
          );
          //link is internal render as gatsby link
          component = (
            <Link
              to={ modifiedInternalLink }
              className={ `button button-link ${this.props.className}` }
              { ...other }
            >
              {this.props.text || this.props.children}
            </Link>
          );
        } else {
          component = (
            <Link
              href={ this.props.href }
              className={ `button button-link ${this.props.className}` }
              { ...other }
            >
              {this.props.text || this.props.children}
            </Link>
          );
        }
        break;
      case 'video':
        component = (
          <VideoModal
            className={ `button ${
              this.props.className ? this.props.className : ''
            }` }
            hashedId={ this.props.videoID }
            text={ this.props.text }
          />
        );
        break;
    }

    return component;
  }
}

export default Button;
